import React from 'react';
import DescartePage from './descarte.page';
function Descarte () {
  return <DescartePage />;
}

export default Descarte;



// WEBPACK FOOTER //
// ./src/pages/descarte/descarte.container.js